<template>
  <el-col :span="24" style="margin-bottom: 8px">
    <div id="day-count-map">
      <p class="route_tble__dayInfo mr-p" style="margin: inherit">Откликов:</p>
      <img src="@/assets/img/black_truck.svg" />
      <span class="approve">
        {{ day.responses_count_approved }}
      </span>
      /
      <span class="total">
        {{ day.responses_count_not_served }}
      </span>
    </div>
  </el-col>
</template>

<script>
export default {
  name: 'DayCountMap',
  props: {
    day: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="sass">
#day-count-map
  display: flex
  align-items: center
  justify-content: start
  .approve
    margin-left: 10px
    color: #4C9429
  .total
    color: #409EFF
</style>
